import * as React from 'react'

export interface SidebarGuideIconProps extends React.SVGProps<SVGSVGElement> {
  active?: boolean
  size?: number | string
}

export const SidebarGuideIcon = React.forwardRef<SVGSVGElement, SidebarGuideIconProps>(
  ({ active = false, size = 24, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g transform="translate(-6.5, -7) scale(1.35)">
          <path
            d="M31.495 28.2652V13.8752C31.495 13.8252 31.17 13.1302 30.605 12.9702C30.605 12.9702 30.55 20.8852 30.495 23.6452C30.485 24.1852 30.505 24.7302 30.495 25.2702C28.455 24.6202 26.105 24.9602 24.185 25.8252C22.665 26.5052 21.08 27.5902 20.29 29.0802C20.29 29.0802 20.98 28.5802 21.07 28.5102C23.405 26.7402 25.91 26.5352 28.745 27.2452C29.705 27.4852 30.595 27.8902 31.5 28.2752L31.495 28.2652Z"
            fill={active ? '#0B2948' : '#FBFBFB'}
          />
          <path
            d="M29.65 24.2451L29.75 11.1901C28.715 10.8401 27.545 10.8901 26.47 11.0351C24.57 11.2901 22.535 11.9051 20.98 13.0701C20.155 13.6851 19.75 14.6201 19.75 14.6201C19.75 14.7651 19.75 23.7701 19.76 28.0101C20.12 27.5851 20.445 27.0601 20.86 26.6851C22.515 25.1851 24.785 24.3951 26.985 24.1651C27.875 24.0701 28.77 24.0501 29.645 24.2451H29.65Z"
            fill="#61C9DC"
          />
          <path
            d="M11.3998 24.1651C13.6048 24.3951 15.8748 25.1851 17.5248 26.6851C17.9398 27.0601 18.2648 27.5851 18.6248 28.0101C18.6348 23.7751 18.6398 14.7651 18.6348 14.6201C18.6348 14.6201 18.2298 13.6901 17.4048 13.0701C15.8498 11.9051 13.8198 11.2901 11.9148 11.0351C10.8398 10.8901 9.66977 10.8401 8.63477 11.1901L8.73477 24.2451C9.61477 24.0501 10.5048 24.0701 11.3948 24.1651H11.3998Z"
            fill={active ? '#0B2948' : '#FBFBFB'}
          />
        </g>
      </svg>
    )
  },
)

SidebarGuideIcon.displayName = 'SidebarGuideIcon'
